import "../styles/Maintenance.css";
const ESPACES = [
  "Corner nutrition",
  "Corner inscriptions",
  "Espace renseignements",
  "Rencontres coachs / formateurs",
];

const PILLS = ["Check-in visiteurs", "Welcome drink", "DJ set", "Diffusion vidéos"];

const PLANNING_LEFT = [
  {
    time: "13H30 — ACCUEIL DES INVITÉS",
    body: "Ambiance lounge / sportive / premium.",
  },
  {
    pill: "IMMERSION TRAINING",
    time: "14H00 — Opening Talk",
    quote: "« Pourquoi former une nouvelle génération de coachs ? »",
    body: "Contenu : Vision du Hyve, évolution du métier, importance du coaching humain, opportunités du CQP",
  },
  {
    pill: "ROTATION DES SÉANCES",
    time: "14H30 — Expérience",
    blocks: [
      {
        title: "BOOTCAMP — 20 min",
        text: "Énergie, coaching collectif, intensité, motivation. Le formateur explique posture, gestion de groupe et dynamique.",
      },
      {
        title: "HOT PILATES — 20 min",
        text: "Ambiance profonde et sensorielle, respiration, contrôle, gainage, mobilité. Maîtrise du corps et présence.",
      },
      {
        title: "REFORMER PILATES — 20 min",
        text: "Découverte premium du Reformer, technique, fluidité, posture, relation coach / client.",
      },
    ],
  },
  {
    time: "15H45 — PAUSE / NETWORKING",
    body: "Moment social : échanges avec les coachs et en-cas.",
    list: ["Interviews vidéos", "Photos", "Témoignages spontanés"],
  },
];

const PLANNING_RIGHT = [
  {
    pill: "IMMERSION MÉTIERS",
    time: "16H15 — ATELIER : « DEVENIR COACH AUJOURD’HUI »",
    list: [
      "Vivre du coaching",
      "Construire son image",
      "Réseaux sociaux",
      "Fidéliser ses clients",
      "Erreurs du métier",
    ],
    body: "Format : questions / réponses + échanges libres.",
  },
  {
    time: "17H00 — ATELIER PRATIQUE COACHING",
    subtitle: "Les visiteurs deviennent coachs.",
    list: [
      "Correction posture",
      "Prise de parole",
      "Motivation partenaire",
      "Gestion énergie groupe",
    ],
  },
  {
    time: "17H45 — BLOC EXPÉRIENCE #2",
    body: "3 mini-cours de 20 minutes en rotation (Bootcamp, Hot Pilates, Reformer). Les visiteurs sont mis en situation de coaching avec démonstrations et échanges interactifs.",
  },
  {
    time: "19H00 — PRÉSENTATION OFFICIELLE DU CQP",
    body: "Programme, certification, débouchés, financement, stages, opportunités chez Le Hyve.",
  },
  { time: "19H30 — INSCRIPTIONS & ENTRETIENS INDIVIDUELS" },
  { time: "20H00 — DJ SET / SOCIAL / CONTENT" },
];

export default function Maintenance() {
  return (
    <div className="maintenance-page">
      <section className="jpo-hero-banner">
      <img
        src="/Assets/imgMaintenance.png"
        alt="Journée Portes Ouvertes — Le Hyve Academy, 13 juin 2026"
      />
      <a href="/lehyve_formation.html" className="jpo-hero-btn">
        DÉCOUVRIR LA FORMATION
      </a>
    </section>

      <section className="jpo-intro">
        <div className="jpo-intro-grid">
          <div>
            <h2>JOURNÉE PORTES OUVERTES</h2>
            <p className="jpo-intro-sub">
              Format Afterwork Immersif —{" "}
              <em>Entre dans la peau d&apos;un coach - Option musculation - option personal training</em>
            </p>
            <p className="jpo-intro-text">
              Une après-midi pensée comme une montée en intensité. Le but
              n&apos;est pas seulement de présenter une formation mais de faire
              ressentir ce qu&apos;est LE HYVE : énergie, présence, pédagogie,
              dépassement et culture du mouvement.
            </p>
          </div>
          <h2 className="jpo-intro-aside">CQP LE HYVE ACADEMY</h2>
        </div>

        <div className="jpo-pills">
          {PILLS.map((label) => (
            <span key={label} className="jpo-pill">
              {label}
            </span>
          ))}
        </div>
      </section>

      <section className="jpo-planning">
        <p className="planning-label">ESPACES OUVERTS :</p>
        <div className="planning-tags">
          {ESPACES.map((item) => (
            <span key={item} className="planning-tag">
              {item}
            </span>
          ))}
        </div>
        <h2 className="planning-title">PLANNING OFFICIEL</h2>

        <div className="planning-columns">
          <div className="planning-col">
            {PLANNING_LEFT.map((block) => (
              <article key={block.time || block.pill} className="planning-block">
                {block.pill ? (
                  <span className="planning-pill-dark">{block.pill}</span>
                ) : null}
                {block.time ? <h3>{block.time}</h3> : null}
                {block.quote ? <p className="planning-quote">{block.quote}</p> : null}
                {block.body ? <p>{block.body}</p> : null}
                {block.blocks?.map((b) => (
                  <div key={b.title} className="planning-sub">
                    <h4>{b.title}</h4>
                    <p>{b.text}</p>
                  </div>
                ))}
                {block.list ? (
                  <ul>
                    {block.list.map((li) => (
                      <li key={li}>{li}</li>
                    ))}
                  </ul>
                ) : null}
              </article>
            ))}
          </div>

          <div className="planning-col">
            {PLANNING_RIGHT.map((block) => (
              <article key={block.time || block.pill} className="planning-block">
                {block.pill ? (
                  <span className="planning-pill-dark">{block.pill}</span>
                ) : null}
                {block.time ? <h3>{block.time}</h3> : null}
                {block.subtitle ? <p className="planning-subtitle">{block.subtitle}</p> : null}
                {block.body ? <p>{block.body}</p> : null}
                {block.list ? (
                  <ul>
                    {block.list.map((li) => (
                      <li key={li}>{li}</li>
                    ))}
                  </ul>
                ) : null}
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="jpo-quote">
        <a href="mailto:contact@le-hyve.com" className="jpo-quote-contact">
          ✉ contact@le-hyve.com
        </a>
        <p className="jpo-quote-text">
          <span className="sans">NOTRE CQP EST UNE </span>
          <span className="serif">PORTE D&apos;ENTRÉE,</span>
          <br />
          <span className="sans">UNE TRANSFORMATION, UNE </span>
          <span className="serif">AVENTURE HUMAINE</span>
        </p>
      </section>

     
    </div>
  );
}
